import type React from 'react';
import { useEffect, useState } from 'react';
import { Navigate } from 'react-router';

import { isAuthSessionActive, useAuthSession } from 'hooks/useAuthSession';
import { resolvePostLoginPath } from 'utils/postLoginNavigation';
import { BrandLoader } from 'ui/BrandLoader/BrandLoader';

type GuestOnlyGuardProps = {
  children: React.ReactElement;
};

const SESSION_WAIT_MS = 10_000;

/** Гостевые страницы (/login): авторизованных сразу в кабинет. */
export const GuestOnlyGuard: React.FC<GuestOnlyGuardProps> = ({ children }) => {
  const { data: session, isLoading, isError } = useAuthSession();
  const [gaveUp, setGaveUp] = useState(false);

  useEffect(() => {
    const timer = window.setTimeout(() => setGaveUp(true), SESSION_WAIT_MS);
    return () => window.clearTimeout(timer);
  }, []);

  if (isAuthSessionActive(session)) {
    const path = resolvePostLoginPath(session?.roles ?? []);
    // Authenticated with no usable role would resolve to /login and Navigate-loop.
    if (path === '/login') {
      return children;
    }
    return <Navigate to={path} replace />;
  }

  if (isLoading && !gaveUp) {
    return <BrandLoader center label='Загрузка...' />;
  }

  if (isError || (gaveUp && isLoading)) {
    return (
      <>
        <p role='status' style={{ margin: '16px auto', maxWidth: 480, textAlign: 'center' }}>
          Не удалось проверить, выполнен ли вход. Можно войти заново.
        </p>
        {children}
      </>
    );
  }

  return children;
};
